import { render } from "./common.vue?vue&type=template&id=4d9602ac&scoped=true&ts=true"
import script from "./common.vue?vue&type=script&lang=ts"
export * from "./common.vue?vue&type=script&lang=ts"

import "./common.vue?vue&type=style&index=0&id=4d9602ac&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9602ac"]])

export default __exports__